// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__rQiaG","loader":"MediumLoader_loader__HvdpT","spinner-c7wet2":"MediumLoader_spinner-c7wet2__-e6f7"};